// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/get_assay_data_request.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { FieldMask } from "../../../../google/protobuf/field_mask_pb";
import { file_google_protobuf_field_mask } from "../../../../google/protobuf/field_mask_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/get_assay_data_request.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_get_assay_data_request: GenFile = /*@__PURE__*/
  fileDesc("CkRxdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvZ2V0X2Fzc2F5X2RhdGFfcmVxdWVzdC5wcm90bxIncXVhbnRlcml4LnNpbW9hX29uZS5hbmFseXNpc19hcHBfYXBpLnYxInkKE0dldEFzc2F5RGF0YVJlcXVlc3QSFQoIYXNzYXlfaWQYASABKAlIAIgBARIxCghnZXRfbWFzaxgCIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5GaWVsZE1hc2tIAYgBAUILCglfYXNzYXlfaWRCCwoJX2dldF9tYXNrYgZwcm90bzM", [file_google_protobuf_field_mask]);

/**
 * Rpc request to retrieve assay data
 *
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.GetAssayDataRequest
 */
export type GetAssayDataRequest = Message<"quanterix.simoa_one.analysis_app_api.v1.GetAssayDataRequest"> & {
  /**
   * Unique identifier (UUID) of the assay
   *
   * @generated from field: optional string assay_id = 1;
   */
  assayId?: string;

  /**
   * Represents a set of field paths to be returned in the get request. If
   * omitted, all fields are included in the response
   *
   * See: https://protobuf.dev/reference/protobuf/google.protobuf/#field-mask
   *
   * @generated from field: optional google.protobuf.FieldMask get_mask = 2;
   */
  getMask?: FieldMask;
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.GetAssayDataRequest.
 * Use `create(GetAssayDataRequestSchema)` to create a new message.
 */
export const GetAssayDataRequestSchema: GenMessage<GetAssayDataRequest> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_get_assay_data_request, 0);

